import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ZoomMtgEmbedded from '@zoom/meetingsdk/embedded';
import CryptoJS from 'crypto-js';

function LiveClassRoute() {
    const { meetingId } = useParams(); 
    const navigate = useNavigate();

    // ⚠️ أرجوك غير الـ Secret ده فوراً بعد ما تخلص تجربة لأنه أصبح مكشوف
    const sdkKey = 'btXOgzVbRfSyaIG7RanIKg'; 
    const sdkSecret = 'd7PPwGiyWs0JEySdo2BJAEvAZutg6cTH'; 
    
    const passWord = 'xbZ4E7'; 
    const userName = 'Eng. Youssef Abdo'; 
    const role = 0; 
    
    const clientRef = useRef(null);
    const isMeetingStarted = useRef(false);

    const generateSignature = () => {
        const iat = Math.floor(Date.now() / 1000) - 90; 
        const exp = iat + 60 * 60 * 2;
        const header = { alg: 'HS256', typ: 'JWT' };
        
        const cleanMeetingId = Number(meetingId.replace(/-/g, ''));
        const numericRole = Number(role);

        const payload = {
            sdkKey: sdkKey,
            appKey: sdkKey,
            mn: cleanMeetingId,
            role: numericRole,
            iat: iat,
            exp: exp,
            tokenExp: exp
        };

        const base64UrlEncode = (str) => btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        const encodedHeader = base64UrlEncode(JSON.stringify(header));
        const encodedPayload = base64UrlEncode(JSON.stringify(payload));

        const cryptoSignature = CryptoJS.HmacSHA256(`${encodedHeader}.${encodedPayload}`, sdkSecret);
        const encodedSignature = CryptoJS.enc.Base64.stringify(cryptoSignature)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');

        const finalSignature = `${encodedHeader}.${encodedPayload}.${encodedSignature}`;
        console.log("My Signature:", finalSignature); 
        return finalSignature;
    };

    useEffect(() => {
        if (isMeetingStarted.current) return;
        isMeetingStarted.current = true;
        
        const initMeeting = async () => {
            clientRef.current = ZoomMtgEmbedded.createClient();
            
            // التشفير اتخزن هنا في currentSignature
            const currentSignature = generateSignature();
            const meetingContainer = document.getElementById('zoom-meeting-container');

            clientRef.current.init({
                zoomAppRoot: meetingContainer,
                language: 'en-US',
                customize: {
                    video: {
                        isResizable: true,
                        viewSizes: {
                            default: { width: 1000, height: 600 },
                            ribbon: { width: 300, height: 600 }
                        }
                    }
                }
            });

            try {
                await clientRef.current.join({
                    signature: currentSignature, // <--- التعديل هنا: استخدمنا المتغير الصح
                    meetingNumber: meetingId,
                    password: passWord,
                    userName: userName,
                    userEmail: ''
                });
                console.log('تم الدخول للميتينج بنجاح!');
            } catch (error) {
                console.error('خطأ في الدخول (Join):', error);
            }
        };

        initMeeting();

        return () => {
            if (clientRef.current) {
                // clientRef.current.leaveMeeting();
            }
        };
    }, [meetingId]);

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#f0f2f5', padding: '20px' }}>
            <h2 style={{ marginBottom: '20px' }}>البث المباشر للحصة</h2>
            <div id="zoom-meeting-container" style={{ width: '100%', maxWidth: '1000px', height: '600px', backgroundColor: '#000', borderRadius: '10px', overflow: 'hidden' }}></div>
        </div>
    );
}

export default LiveClassRoute;